import printersService from '../../services/printer'

const state = {
  printer: {
      deviceId : '',
      restaurantId: ''
  },

}

// getters
const getters = {
 
}

// actions
const actions = {
    async getPrinterAction (context) {
        await printersService.getPrinterByRestaurant()
                            .then( data => 
                              { context.commit('setPrinterState', data) }); 
    },
    
    async updatePrinterAction (context) {

    },
    
}

// mutations
const mutations = {
    setPrinterState(state, printer) {
        state.printer = printer;
    },

    updateTaxState(state, tax) {

    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}